/**
 * 全局枚举
 * - 命名规范：PascalCase
 * - 数值型枚举须与后端一致；字符串枚举优先于数值枚举
 */

/** HTTP 业务状态码 */
export enum BizCode {
  SUCCESS = 0,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  SERVER_ERROR = 500,
}

/** 订单状态 */
export enum OrderStatus {
  Pending = 1,
  Processing = 2,
  Completed = 3,
  Cancelled = 4,
}

/** 订单状态文案映射 */
export const OrderStatusMap: Record<OrderStatus, string> = {
  [OrderStatus.Pending]: '待处理',
  [OrderStatus.Processing]: '进行中',
  [OrderStatus.Completed]: '已完成',
  [OrderStatus.Cancelled]: '已取消',
}

/** 用户类型 */
export enum UserType {
  Normal = 'normal',
  Vip = 'vip',
  Admin = 'admin',
}

/** 性别 */
export enum Gender {
  Unknown = 0,
  Male = 1,
  Female = 2,
}
